import {DUMMY_PILLS, TEAM_SIZE_OPTIONS, REASON_OPTIONS, DATA_SOURCE_OPTIONS} from './consts';
import type {FormValues} from './types';

export function convertDataToFormValues(
    companyName: string,
    website: string,
    workPhone: string,
    textMessageOptIn: boolean,
    whatBringsYou: string[],
    teamSize: string,
    whereIsYourData: string[]
): FormValues {
    return {
        companyName,
        website,
        workPhone,
        textMessageOptIn,
        whatBringsYou,
        teamSize,
        whereIsYourData,
    };
}

export function generateDynamicPills(
    teamSize: string,
    website: string,
    whatBringsYou: string[],
    whereIsYourData: string[]
): string[] {
    const pills: string[] = [];

    // Website pill
    if (website.trim() !== '') {
        pills.push(`Your website is ${website}`);
    }
    // What brings you pill
    if (whatBringsYou && whatBringsYou.length > 0) {
        const firstReason = whatBringsYou[0];
        const reasonOption = REASON_OPTIONS.find((option) => option.value === firstReason);
        if (reasonOption && reasonOption.pillText) {
            pills.push(reasonOption.pillText);
        }
    }

    // Team size pill
    const teamSizeOption = TEAM_SIZE_OPTIONS.find((option) => option.value === teamSize);
    if (teamSizeOption && teamSizeOption.pillText) {
        pills.push(teamSizeOption.pillText);
    }

    // Where is your data pill
    if (whereIsYourData && whereIsYourData.length > 0) {
        const firstDataSource = whereIsYourData[0];
        const dataSourceOption = DATA_SOURCE_OPTIONS.find(
            (option) => option.value === firstDataSource
        );
        if (dataSourceOption && dataSourceOption.pillText) {
            pills.push(dataSourceOption.pillText);
        }
    }

    let dummyIndex = 0;
    while (pills.length < 5) {
        // @ts-expect-error
        pills.push(DUMMY_PILLS[dummyIndex]);
        dummyIndex++;
    }

    return pills;
}
